import Database from '@nozbe/watermelondb/Database';

import { LoggerFunction } from '../../types/logger';
import DBService from './DBService.web';

class DatabaseService {
    static instance: Database;

    static getDatabase({
        onSetUpError,
    }: { onSetUpError?: LoggerFunction } = {}) {
        if (!this.instance) {
            this.instance = DBService(onSetUpError);
        }

        return this.instance;
    }
}

export default DatabaseService;
